import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class RiskConvergenceService {
  constructor(private readonly http: HttpClient) { }

  projectList() {
    return this.http.get("delivery/project-list?flag=mapped_list");
  }

  getVendorList() {
    return this.http.get(
      "dynamic-form/?form_name=opportunity_empanelled_vendors"
    );
  }

  getRiskFunctionOwners(functionId: number) {
    return this.http.get(
      `risk/risks/function-owners/?function_id=${functionId}`
    );
  }

  getRiskMaster(filterString = "") {
    return this.http.get(`risk/risks/?${filterString}`);
  }

  getRiskProject(queryParam: any) {
    return this.http.get(`delivery/get-risk-goal-project/?${queryParam}`);
  }

  getRiskApplication(queryParam: any) {
    return this.http.get(`master/application/list-unique/?${queryParam}`);
  }

  updateRisk(payload: any) {
    return this.http.post(`risk/risks/`, payload);
  }

  getRiskTracker(offSet?: any, end?: any) {
    const params = `offset=${offSet}&index=${end}`;
    return this.http.get(`risk/project-risks/?${params}`);
  }

  getFilteredRiskTracker(offSet?: any, end?: any, queryParams: string = "") {
    let params = "";
    if (offSet !== undefined && end !== undefined && offSet !== null && end !== null) {
      params = `offset=${offSet}&index=${end}${queryParams}`;
    } else {
      params = queryParams.startsWith("&") ? queryParams.substring(1) : queryParams;
    }
    return this.http.get(`risk/project-risks/?${params}`);
  }

  downloadTrackerList(queryParam: any) {
    return this.http.get(`risk/project-risks/?response_type=csv${queryParam}`, {
      responseType: "blob",
    });
  }

  deleteFile(fileId: number) {
    return this.http.delete(`risk/project-risks/delete-file?file_id=${fileId}`);
  }

  downloadFile(fileId: number) {
    return this.http.post(`risk/project-risks/download-file/${fileId}`, {
      responseType: "blob",
    });
  }

  getRiskPulse() {
    return this.http.get("nps/pulses/?performance_impact=Risk");
  }

  getRiskImpactList() {
    return this.http.get("risk/project-risks/risk-impact");
  }

  getRiskLikelihoodList() {
    return this.http.get("risk/project-risks/risk-likelihood");
  }

  getRiskScoreRange() {
    return this.http.get("risk/project-risks/risk-score-range");
  }

  getActionAgeingRange() {
    return this.http.get("risk/project-risks/action-ageing");
  }

  getRiskStatusList() {
    return this.http.get("risk/project-risks/risk-status");
  }

  getRiskControlTypes() {
    return this.http.get("risk/project-risks/risk-control-types");
  }

  getRiskTypes() {
    return this.http.get("risk/risks/risk-types");
  }

  getRiskControls(riskId: number) {
    return this.http.get(`risk/project-risks/${riskId}/risk-controls/`);
  }

  getRiskMatrixData(projectId: number) {
    return this.http.get(`risk/project-risks/${projectId}/risk-matrix`)
  }

  getRiskHistory(riskId: number) {
    return this.http.get(`risk/project-risks/${riskId}/history`)
  }

  getRiskPrefix() {
    return this.http.get(`risk/risks/company-prefix`)
  }
}
